/**
 * API origins — aligned with chillnpark_admin `src/constants/api.ts`.
 * Hostname picks the server; customDev uses https://react.customdev.solutions:3086.
 */

const { hostname } = window.location;

const servers = {
  local: "http://localhost:3086",
  customDev: "https://react.customdev.solutions:3086",
  live: "https://react.customdev.solutions:3086",
};

/** @type {string} */
let originURL;

// Manual override (dev/testing): localStorage.setItem('API_SERVER', 'customDev' | 'local' | 'live')
const manualOverride = localStorage.getItem("API_SERVER");

if (manualOverride && Object.prototype.hasOwnProperty.call(servers, manualOverride)) {
  originURL = servers[manualOverride];
} else if (hostname.includes("react.customdev.solutions")) {
  originURL = servers.customDev;
} else if (hostname.includes("cruisetales.com")) {
  originURL = servers.live;
} else {
  originURL = servers.customDev;
}

const baseOrigin = String(originURL).replace(/\/$/, "");

export const SOCKET_URL = `${baseOrigin}`;
export const UPLOADS_URL = `${baseOrigin}/uploads`;
/** Axios base — same as admin `BASE_URL` (origin + `/api`). */
export const API_BASE_URL = `${baseOrigin}/api`;
export const RADIUS = 10;
